"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from "next/navigation";
import { useSyncExternalStore } from "react";
import { useSite } from "@/contexts/site/site.context";
import { environmentPrefixStore } from "@/hooks/use-current-url-store";
export type CurrentUrl = {
  readonly absolute: string;
  readonly relative: string;
  readonly absoluteDomainName: string;
  readonly domain: string;
  readonly domainWithSubdomain: string;
};
export function useCurrentUrl() {
  const $ = _c(8);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    domain
  } = useSite();
  const environmentPrefix = useSyncExternalStore(environmentPrefixStore.subscribe, environmentPrefixStore.getSnapshot, environmentPrefixStore.getServerSnapshot);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.toString();
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const params = t0;
  const relative = params ? `${pathname}?${params}` : pathname;
  const domainWithSubdomain = `${environmentPrefix}${domain}`;
  const absoluteDomainName = `https://${domainWithSubdomain}`;
  const absolute = `${absoluteDomainName}${relative}`;
  let t1;
  if ($[2] !== absolute || $[3] !== absoluteDomainName || $[4] !== domain || $[5] !== domainWithSubdomain || $[6] !== relative) {
    t1 = {
      absolute,
      absoluteDomainName,
      domain,
      domainWithSubdomain,
      relative
    };
    $[2] = absolute;
    $[3] = absoluteDomainName;
    $[4] = domain;
    $[5] = domainWithSubdomain;
    $[6] = relative;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}